export enum EEntityMatchType {
  Unknown = 0,
  ExternalId = 1,
  Ssn = 2,
  Name = 3,
  Created = 4
}

export enum EEntityImportState {
  Unknown = 0,
  Mapped = 1,
  Imported = 2,
  Failed = 3,
}
